import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetPricingGroupDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface PricingGroupProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  refresh?: boolean;
  onRowClick: (key: string) => Promise<void> | void | undefined;
}

export const pricingGroupForGrid = (pricingGroup: GetPricingGroupDto) => {
  return {
    key: pricingGroup.id,
    values: {
      'pricingGroup.name': pricingGroup.name,
      'pricingGroup.active': pricingGroup.active ? 'Tak' : 'Nie',
    },
    isInactive: !pricingGroup.active,
  };
};

export const PricingGroupSearch: React.FC<PricingGroupProps> = props => {
  const columns = [
    { header: 'Nazwa', property: 'pricingGroup.name' },
    { header: 'Aktywny', property: 'pricingGroup.active' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      onRowClick={props.onRowClick}
      initialOrderColumn="pricingGroup.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage="Brak grup cenowych w systemie"
      enableMultiSelect={false}
      refresh={props.refresh}
      showExport={true}
    />
  );
};
